// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GhR1hXkoMjWysdCp5r3o{display:flex;align-items:center;justify-content:center;height:100%}`, "",{"version":3,"sources":["webpack://./src/shared/ui/SuspenseWithFallback/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,WAAA","sourcesContent":[".wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `GhR1hXkoMjWysdCp5r3o`
};
export default ___CSS_LOADER_EXPORT___;
